/**
 * Auth Service Factory
 * Uses dynamic imports so only the selected provider is loaded and initialized.
 * REACT_APP_AUTH_PROVIDER: 'msal' (default) | 'keycloak'
 */

import { isMsalProvider } from '@config/authConfig';

export interface IAuthService {
  loginWithFallback(): Promise<void>;
  logout(): Promise<void>;
  getAccessToken(): Promise<string>;
  isAuthenticated(): boolean;
  getCurrentUser(): object | null;
}

async function createAuthService(): Promise<IAuthService> {
  if (isMsalProvider) {
    const service = await import('./msalAuthService').then(m => m.default);
    return service as unknown as IAuthService;
  }
  const service = await import('./keycloakAuthService').then(m => m.default);
  return service as unknown as IAuthService;
}

// SonarQube suggests top-level await here, but this module is loaded under Jest
// (ts-jest/babel-jest, see authServiceFactory.test.ts's jest.mock/jest.resetModules
// usage), which transpiles to CommonJS — top-level await isn't valid there and
// would break the test suite. Consumers already `await authService` (it's typed
// as a Promise), so the wrapping async call is kept as-is.
const authService: Promise<IAuthService> = createAuthService();

export default authService;
